






































import { Component, Prop } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import IssueCommentService from '@/services/issue-comment.service';
import { IssueCommentEntity } from '@/entities/issue-comment.entity';
import CEmoticonInput from '@/components/Helper/Form/CEmoticonInput.vue';
import CFileInput from '@/components/Helper/Button/CFileInput.vue';
import CommentBoxMixin from '@/mixin/comment-box.mixin';
import { PropType } from 'vue';
import { IssueEntity } from '@/entities/issue.entity';

@Component<IssueCommentBoxPc>({
  components: { CFileInput, CEmoticonInput },
})
export default class IssueCommentBoxPc extends CommentBoxMixin {
  commentData: Partial<IssueCommentEntity> = {
    issueId: null,
    content: '',
  };

  @Prop({ type: Object as PropType<IssueEntity>, required: true })
  issue: IssueEntity;

  @UseService(IssueCommentService)
  service: IssueCommentService;

  created() {
    this.commentData.issueId = this.issue.id;
  }
}
